module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18547/js/img/valuePropModals/FormConditionalLogic/ValueProp1.svg"